export default __webpack_public_path__ + "static/media/af26ac986a3f14e0e7f2b5b72828a4fe.png";